import * as angular from "angular";

angular
  .module('bringoz.admin.authentication', ['bringoz.admin.commons']);
